export const blockIconsUiactionsArrowDropDownNew = (
	<span className='material-symbols-outlined'>arrow_drop_down</span>
);
